import { FunctionComponent, memo } from "react";

import ThemeHeader from "./themeHeader";
import SectionsAccordion from "../section/sectionsAccordion";

import AccordionList, { AccordionAdditionalItem } from "@components/generic/accordion/accordionList";
import { IBrandSource } from "@lib/store/models/brandsModels";
import { useReferential } from "context/referentialContext";

export interface IThemesAccordionProps {
  brandSourcesByCriteriumId?: { [id: string]: IBrandSource[] };
  additionalLeadingItems?: AccordionAdditionalItem[];
  additionalTrailingItems?: AccordionAdditionalItem[];
}

const ThemesAccordion: FunctionComponent<IThemesAccordionProps> = ({
  brandSourcesByCriteriumId,
  additionalLeadingItems,
  additionalTrailingItems,
}) => {
  const { themes, depth } = useReferential();
  return (
    <AccordionList
      items={themes}
      renderHeader={({ score, code, name }) => <ThemeHeader score={Math.round(score)} name={name} themeCode={code} />}
      renderContent={({ code }) => (
        <SectionsAccordion themeCode={code} brandSourcesByCriteriumId={brandSourcesByCriteriumId} />
      )}
      additionalLeadingItems={additionalLeadingItems}
      additionalTrailingItems={additionalTrailingItems}
      lazy
      withAutoClose
      itemTestId="theme"
      unopenable={depth === "themes"}
    />
  );
};

export default memo(ThemesAccordion);
